import { SelectorOption } from "../../../../components/Redux/BasicSelector";

export const JwtIssuerFormatOptions: SelectorOption[] = [
  {
    label: "None Selected",
    id: "",
  },
  {
    label: "Host Only",
    id: "hostOnly",
  },
  {
    label: "URI",
    id: "uri",
  },
];
